import { customCheckBox } from '../global/_customCheckBox';
import { submitForm } from '../global/_submitForm';
import { dillardsModal } from './_dillardsModal';
import { preventDoubleClick } from '../global/_doubleClick';
import { useAnywayModalFromModal, useAnywayModal } from './_useAnywayModalFromModal';
import { checkCVN2 } from '../checkout/_validation';

export var callAddressVerification = function (params, returnHTML) {
	function myCallback() {
		submitForm();
		preventDoubleClick();
	}
	var phoneInputs = $('.avForm').find('input[type="tel"]');
	if (phoneInputs.length) {
		$.each(phoneInputs, function () {
			$(this).val(
				$(this)
					.val()
					.replace(/[-()\s]/g, '')
			);
		});
	}

	if ($('#pay_data_cvvNumber').length > 0 && $('#pay_data_cvvNumber').val().indexOf('***') == -1 && $('#pay_data_cvvNumber').val().trim() != '') {
		var cardBrand = $('form input[name="qc_pay_cc_brand"]').val();
		if (cardBrand == '' && $('#payment-info-update-card-type').length > 0) {
			cardBrand = $('#payment-info-update-card-type').val().split(',')[3].trim();
		} else if (cardBrand == '' && $('#payment-info-add-card-type').length > 0 && $('#payment-info-add-card-type').val().split(',').length > 2) {
			cardBrand = $('#payment-info-add-card-type').val().split(',')[2].trim();
		}

		if (cardBrand != '' && !checkCVN2(document.getElementById('pay_data_cvvNumber'), cardBrand)) {
			$('html').removeClass('html-modal-open');
			return false;
		}
	}
	if (params.callVerifyAddress == 'false') {
		$('.avForm').submit();
	} else {
		$('.quick-checkout-shipping-address-area input, .quick-checkout-shipping-address-area select').attr('disabled', false);
		$.ajax({
			url: '/webapp/wcs/stores/servlet/DdsAddressVerification',
			cache: false,
			type: 'POST',
			data: $('.avForm').serialize(),
			error: function (response) {
				$('.avForm').submit();
			},
			success: function (response) {
				if (typeof window.injectedAVFunction != 'function' || (typeof window.injectedAVFunction == 'function' && window.injectedAVFunction(response))) {
					if (response.JSONError) {
						$('.avForm').submit();
					} else if (response.JSON) {
						if (response.JSON.JSONError == 'Not Found') {
							//Address not found
							if ($('#errorViewName').val() == 'OrderShippingMethodView') {
								if ($("input[name='callingPage']:eq(1)").val() == 'useAnyway')
									dillardsModal.triggerModal('useAnywayModalFromModal({"callingPage" : "true"})', 'ATTENTION', 'modal-address-verification');
								else useAnywayModalFromModal(response, returnHTML);
							} else useAnywayModal(response, returnHTML);
						}
					} else returnHTML(response, myCallback);
					if ($('body#layoutCheckout').length == 0) {
						customCheckBox();
					}
				}
				return false;
			},
		});
	}
};
